// ESM-Huelle fuer lib/scripts/components/CMP_CMultiClickNumber.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CMultiClickNumber(id)
{
    this.construct(id);

    this.name = "CClickNumber";
    this.htmlType = "span";

    this.properties =
    {
        text:
        {
            caption:
            {
                styles:
                {
                    fontSize: "4.5vh",
                    fontFamily: "Verdana, Sans-Serif"
                }
            },
            styles:
            {
                position: "absolute",
                width: "2vw",
                height: "6vw",
                backgroundColor: ""
            }
        },
        styles:
        {
            left: "1vw",
            top: "10vw"
        }
    }

    this.preCommaDigits = 3;
    this.postCommaDigits = 2;
    this.preCDArray = new Array();
    this.postCDArray = new Array();
}

CMultiClickNumber.prototype = new CComponent;

CMultiClickNumber.prototype.prepare = function()
{
    this.currentLeft = Number(String(this.properties.styles.left).replace("vw",""));
    this.drawNumbers(this.preCommaDigits, this.preCDArray);

    if (this.postCommaDigits > 0)
    {
        this.text = this.addChild(CTextLabel);
        this.text.properties.caption.value = ",";
        this.text.properties = combine(this.text.properties, this.properties.text);
        this.text.properties.styles.left = this.currentLeft + "vw";
        this.text.properties.styles.top = this.properties.styles.top;
        
        this.currentLeft += 1.2;

        this.drawNumbers(this.postCommaDigits, this.postCDArray);
    }

    this.prepared = true;
}

CMultiClickNumber.prototype.drawNumbers = function(amount, targetArray)
{
    var number;

    for (var n = 0; n < amount; n++)
    {
        number = this.addChild(CClickNumber);

        number.properties.text.styles.left = this.currentLeft + "vw";
        number.properties.text.styles.top = this.properties.styles.top;
        number.prepare();

        this.currentLeft += 4;

        targetArray.push(number);
    }
}

CMultiClickNumber.prototype.getValue = function()
{
    var number = "";

    for (var i = 0; i < this.preCommaDigits; i++)
    {
        var next = this.preCDArray[i].getValue();
        number += next.toString();
    }

    if (this.postCommaDigits > 0)
    {
        number += ",";

        for (i = 0; i < this.postCommaDigits; i++)
        {
            next = this.postCDArray[i].getValue();
            number += next.toString();
        }
    }

    return number;
}

CMultiClickNumber.prototype.setValue = function(value)
{
    value = value.toString();
    value = value.replace(".", ",");

    var valueParts = new Array();

    valueParts = value.toString().split(",");

    if (valueParts.length == 1)
        valueParts[1] = "";

    for (var i = 0; i < this.preCommaDigits; i++)
    {
        if (valueParts[0].length - i - 1 >= 0)
            var newValue = parseInt(valueParts[0][valueParts[0].length - i - 1]);
        else
            newValue = 0;

        this.preCDArray[this.preCommaDigits - i - 1].setValue(newValue);
     }

    if (this.postCommaDigits > 0 && valueParts[1].length > 0)
    {
        for (i = 0; i < this.postCommaDigits; i++)
        {
             newValue = parseInt(valueParts[1][i]);
             this.postCDArray[i].setValue(newValue);
       }
    }
}
export { CMultiClickNumber };
